import getElementSelectors from '../shares/lib/getElementSelectors';
import logger from '../shares/lib/logger';
import { swipeIconsUI } from '../shares/ui/swipeIconsUI';

export const createSwipeSdkContainer = (): void => {
  const { swipeSdkContainer } = getElementSelectors();

  if (swipeSdkContainer) {
    logger.warn('The "swipe-sdk-container" ID is already present.');
    return;
  }

  const swipeContainer: HTMLDivElement = document.createElement('div');
  swipeContainer.id = 'swipe-sdk-container';
  // swipeContainer.style.display = 'none';
  swipeContainer.innerHTML = swipeIconsUI();

  document.body.appendChild(swipeContainer);
};
